"use client"

import { MessageCircleOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MessageCircleOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MessageCircleOffIcon = component(Icon)({ as: MessageCircleOff })
